<template>
    <section class="certificate-section">
        <div v-if="isLoading" class="loading">
            <v-progress-circular color="blue-grey" model-value="100"></v-progress-circular>
        </div>
        <div v-else-if="isError" class="error-container">
            <v-card class="error-card" elevation="4">
                <v-card-text class="error-content">
                    <v-icon class="error-icon" size="80">mdi-alert-circle-outline</v-icon>
                    <h2 class="error-title">Certificado no disponible</h2>
                    <p class="error-text">
                        No encontramos un certificado de participación registrado para este estudiante.
                    </p>
                    <!-- <p class="error-hint">
                        Si crees que esto es un error, por favor contacta al departamento académico.
                    </p> -->
                </v-card-text>
            </v-card>
        </div>
        <div v-else class="certificate-card">
            <header class="certificate-header">
                <img class="certificate-image" src="/images/logo_largo.png" alt="Logo" />
                <div class="certificate-badge">
                    <span class="badge-label">CERTIFICADO VÁLIDO</span>
                </div>
            </header>

            <div class="certificate-title">
                <p class="subtitle">Estudiante</p>
                <h1 class="student-name">{{ certificado.nombre_estudiante }}</h1>
            </div>

            <div class="certificate-content">
                <p class="lead">Participó en el congreso:</p>
                <h2 class="event-name">{{ certificado.descripcion_congreso }}</h2>
                <p class="event-detail">Realizado en {{ certificado.lugar }} el {{ fecha_evento_normalizada }}</p>
            </div>

            <div class="certificate-meta">
                <div class="meta-item">
                    <span class="meta-label">Gestión</span>
                    <span class="meta-value">{{ certificado.gestion }}</span>
                </div>
                <div class="meta-item">
                    <span class="meta-label">Horas académicas</span>
                    <span class="meta-value">{{ certificado.horas }}</span>
                </div>
                <!-- <div class="meta-item">
                    <span class="meta-label">Fecha de emisión</span>
                    <span class="meta-value">{{ fecha_emision_normalizada }}</span>
                </div> -->
            </div>

                <!-- <footer class="certificate-footer">
            <div class="signature">
                <span class="signature-line"></span>
                <span class="signature-label">Responsable académico</span>
            </div>
            </footer> -->

                <div class="validation-url">
            <span class="validation-url-label">URL de validación</span>
            <a class="validation-url-value" :href="currentUrl" target="_blank" rel="noopener">
                {{ currentUrl }}
            </a>
            </div>
        </div>
    </section>
</template>
<script>

import axios from 'axios';

export default {
    data() {
        return {
            certificado: {
                nombre_estudiante: '',
                unicodigo: '',
                descripcion_congreso: '',
                gestion: '',
                lugar: '',
                fecha_emision: '',
                fecha_evento: '',
                horas: '',
            },
            isLoading: true,
            isError: false,
            currentUrl: '',
        };
    },
    computed: {
        fecha_evento_normalizada() {
            if (!this.certificado.fecha_evento) return '';
            const date = new Date(this.certificado.fecha_evento);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return date.toLocaleDateString('es-ES', options);
        },
        fecha_emision_normalizada() {
            if (!this.certificado.fecha_emision) return '';
            const date = new Date(this.certificado.fecha_emision);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return date.toLocaleDateString('es-ES', options);
        },
    },

    mounted() {
        if (typeof window !== 'undefined') {
            this.currentUrl = window.location.href;
        }
        const id = this.$route.params.id;
        const unicodigo = this.$route.params.unicodigo;
         axios.get(`pagos/certificadocongreso/${id},${unicodigo}`)
            .then(response => {
                if (response.data.length === 0) {
                    this.isError = true;
                    this.isLoading = false;
                } else {
                    this.isError = false;
                    this.isLoading = false;
                    this.certificado = response.data[0];
                    console.log('Certificado data:', response.data);
                }
            })
            .catch(error => {
                this.isError = true;
                this.isLoading = false;
                console.error('Error fetching certificado:', error, this.isError);
            });
    },
};

</script>

<style scoped>
.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
}

.error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 40px 20px;
    background: radial-gradient(circle at top, #f5f8ff 0%, #ffffff 45%, #f1f4f9 100%);
}

.error-card {
    width: min(600px, 100%);
    border-radius: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
}

.error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 32px !important;
}

.error-icon {
    color: #f44336;
    margin-bottom: 16px;
}

.error-title {
    font-size: 28px;
    font-weight: 600;
    color: #1f2a44;
    margin: 16px 0 12px 0;
}

.error-text {
    font-size: 16px;
    color: #4c5a77;
    margin: 12px 0;
    line-height: 1.6;
}

.error-hint {
    font-size: 14px;
    color: #7b88a6;
    margin-top: 16px;
    font-style: italic;
    opacity: 0.85;
}

.certificate-section {
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: radial-gradient(circle at top, #f5f8ff 0%, #ffffff 45%, #f1f4f9 100%);
    color: #1f2a44;
    font-family: "Segoe UI", "Inter", "Roboto", Arial, sans-serif;
}

.certificate-card {
    width: min(980px, 100%);
    background: #ffffff;
    border-radius: 20px;
    padding: 40px 48px;
    box-shadow: 0 24px 60px rgba(31, 42, 68, 0.14);
    border: 1px solid rgba(31, 42, 68, 0.08);
    position: relative;
    overflow: hidden;
}

.certificate-card::before,
.certificate-card::after {
    content: "";
    position: absolute;
    width: 240px;
    height: 240px;
    background: radial-gradient(circle, rgba(69, 110, 255, 0.15), transparent 70%);
    border-radius: 50%;
    z-index: 0;
}

.certificate-card::before {
    top: -120px;
    right: -80px;
}

.certificate-card::after {
    bottom: -140px;
    left: -100px;
}

.certificate-card>* {
    position: relative;
    z-index: 1;
}

.certificate-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 30px;
}

.certificate-image {
    width: min(420px, 80vw);
    max-width: 80%;
    height: auto;
    object-fit: contain;
}

.certificate-badge {
    background: linear-gradient(135deg, #2e5bff, #6b8bff);
    color: #ffffff;
    padding: 14px 18px;
    border-radius: 14px;
    text-align: right;
    min-width: 200px;
    box-shadow: 0 12px 30px rgba(46, 91, 255, 0.35);
}

.badge-label {
    display: block;
    font-size: 12px;
    letter-spacing: 0.18em;
    font-weight: 600;
    text-transform: uppercase;
    opacity: 0.85;
}

.badge-code {
    display: block;
    font-size: 18px;
    font-weight: 700;
    margin-top: 6px;
    word-break: break-all;
}

.certificate-title {
    text-align: center;
    margin-bottom: 24px;
}

.subtitle {
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.3em;
    color: #6c7a95;
    margin-bottom: 8px;
}

.student-name {
    font-size: clamp(28px, 4vw, 40px);
    margin: 0;
    font-weight: 700;
    color: #1f2a44;
}

.certificate-content {
    text-align: center;
    margin-bottom: 32px;
}

.lead {
    font-size: 16px;
    color: #4c5a77;
    margin-bottom: 6px;
}

.event-name {
    font-size: clamp(22px, 3.5vw, 30px);
    margin: 8px 0;
    color: #2e3a57;
}

.event-detail {
    font-size: 15px;
    color: #6b7894;
}

.certificate-meta {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 32px;
}

.meta-item {
    background: #f7f9fc;
    border-radius: 12px;
    padding: 14px 16px;
    border: 1px solid rgba(31, 42, 68, 0.06);
}

.meta-label {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #7b88a6;
    margin-bottom: 6px;
}

.meta-value {
    font-size: 16px;
    font-weight: 600;
    color: #1f2a44;
}

.certificate-footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 10px;
}

.validation-url {
    margin-top: 24px;
    padding: 16px 18px;
    border-radius: 12px;
    background: #f7f9fc;
    border: 1px dashed rgba(46, 91, 255, 0.4);
    text-align: center;
    word-break: break-all;
}

.validation-url-label {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    color: #7b88a6;
    margin-bottom: 8px;
}

.validation-url-value {
    color: #2e5bff;
    font-weight: 600;
    text-decoration: none;
    font-size: 14px;
}

.validation-url-value:hover {
    text-decoration: underline;
}

.signature {
    flex: 1;
    min-width: 200px;
}

.signature-line {
    display: block;
    height: 2px;
    width: 100%;
    background: #d5dbea;
    margin-bottom: 8px;
}

.signature-label {
    font-size: 13px;
    color: #7b88a6;
}

.validation {
    text-align: right;
    min-width: 200px;
}

.validation-label {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: #7b88a6;
    margin-bottom: 6px;
}

.validation-code {
    font-size: 18px;
    font-weight: 700;
    color: #2e5bff;
    word-break: break-all;
}

@media (max-width: 768px) {
    .certificate-card {
        padding: 24px 16px;
    }

    .certificate-header {
        justify-content: center;
        margin-bottom: 16px;
    }

    .certificate-badge {
        width: 100%;
        text-align: center;
        padding: 8px 8px;
    }

    .certificate-footer {
        flex-direction: column;
        align-items: flex-start;
    }

    .validation {
        text-align: left;
    }

    .subtitle {
        font-size: 12px;
        letter-spacing: 0.2em;
    }

    .certificate-title {
        margin-bottom: 8px;
    }

    .certificate-content {
        margin-bottom: -4px;
    }   

    .certificate-meta {
        margin-bottom: -12px;
    }

    .student-name {
        font-size: 16px;
    }

    .lead {
        font-size: 14px;
    }

    .event-name {
        font-size: 12px;
    }

    .event-detail {
        font-size: 13px;
    }
    .meta-item {
        padding: 8px 12px;
    }
    .meta-label {
        font-size: 8px;
        margin-bottom: -2px;
    }

    .meta-value {
        font-size: 12px;
    }

    .badge-label {
        font-size: 12px;
    }

    .validation-url {
        padding: 8px 10px;
    }

    .validation-url-label {
        font-size: 10px;
        margin-bottom: 0px;
    }

    .validation-url-value {
        font-size: 9px
    }
}

@media (max-width: 768px) {
    .error-content {
        padding: 32px 20px !important;
    }

    .error-title {
        font-size: 22px;
    }

    .error-text {
        font-size: 14px;
    }

    .error-hint {
        font-size: 12px;
    }
}
</style>